export const MAX_INVENTORY_PHOTOS = 10;

function legacyPhotoId(url) {
  let hash = 2166136261;
  for (const character of url) {
    hash ^= character.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return `legacy-${(hash >>> 0).toString(36)}`;
}

export function normalizedPhotos(item = {}) {
  const seen = new Set();
  const photos = (Array.isArray(item.photos) ? item.photos : [])
    .filter((photo) => photo && typeof photo.id === "string" && typeof photo.url === "string")
    .map((photo) => ({
      id: photo.id.trim(),
      url: photo.url.trim(),
      ...(Number.isInteger(photo.width) && photo.width > 0 ? { width: photo.width } : {}),
      ...(Number.isInteger(photo.height) && photo.height > 0 ? { height: photo.height } : {}),
    }))
    .filter((photo) => photo.id && photo.url && !seen.has(photo.id) && seen.add(photo.id))
    .slice(0, MAX_INVENTORY_PHOTOS);
  if (photos.length === 0 && item.image) photos.push({ id: legacyPhotoId(item.image), url: item.image });
  return photos;
}

export function selectedCoverId(item = {}, photos = normalizedPhotos(item)) {
  return photos.some((photo) => photo.id === item.coverPhotoId) ? item.coverPhotoId : photos[0]?.id ?? null;
}

export function coverPhoto(item = {}) {
  const photos = normalizedPhotos(item);
  const coverId = selectedCoverId(item, photos);
  return photos.find((photo) => photo.id === coverId) ?? photos[0] ?? null;
}

export function movePhoto(photos, photoId, offset) {
  const next = [...photos];
  const from = next.findIndex((photo) => photo.id === photoId);
  const to = from + offset;
  if (from < 0 || to < 0 || to >= next.length) return next;
  [next[from], next[to]] = [next[to], next[from]];
  return next;
}

export function removePhoto(photos, photoId) {
  return photos.filter((photo) => photo.id !== photoId);
}
